import { Rule } from "rc-field-form/lib/interface";

export const ruleMin = (min: number): Rule => ({
  min,
  type: "number",
  message: `Значение не может быть меньше ${min}`,
});
